"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Health = void 0;
var pixi_js_1 = require("pixi.js");
var rxjs_1 = require("rxjs");
var HitSplats_1 = require("./HitSplats");
var app_1 = require("../../app");
var Health = function (_a) {
    var maxHP = _a.maxHP, sprite = _a.sprite, _b = _a.hideHealthBar, hideHealthBar = _b === void 0 ? false : _b, type = _a.type;
    var hp = maxHP;
    var onDeath = new rxjs_1.AsyncSubject();
    var onHealthChange = new rxjs_1.Subject();
    var healthBar = null;
    if (!hideHealthBar) {
        healthBar = HealthBar({ maxHP: maxHP, hp: hp, sprite: sprite });
    }
    var spawnHitSplat = (0, HitSplats_1.HitSplats)(sprite, type).spawnHitSplat;
    var kill = function () {
        takeDamage(hp);
    };
    var takeDamage = function (amount, isCrit) {
        if (isCrit === void 0) { isCrit = false; }
        if (amount < 0) {
            console.error("cannot deal negative damage.");
            return;
        }
        spawnHitSplat(amount, isCrit);
        if (amount === 0)
            return;
        hp = Math.max(0, hp - amount);
        healthBar === null || healthBar === void 0 ? void 0 : healthBar.updateHealth(hp, maxHP);
        onHealthChange.next({ type: 'damage', amount: amount });
        if (hp <= 0) {
            hp = 0;
            // TODO: why can't TS allow onDeath.next()?
            // @ts-ignore
            onDeath.next();
            onDeath.complete();
            onHealthChange.complete();
            healthBar.clearHealthBar();
        }
    };
    var heal = function (amount) {
        if (hp === maxHP)
            return;
        hp = Math.min(hp + amount, maxHP);
        healthBar === null || healthBar === void 0 ? void 0 : healthBar.updateHealth(hp, maxHP);
        onHealthChange.next({ type: 'heal', amount: amount });
    };
    var getHP = function () { return hp; };
    var setMaxHP = function (newMaxHP) {
        healthBar === null || healthBar === void 0 ? void 0 : healthBar.updateHealth(hp, newMaxHP);
        maxHP = newMaxHP;
    };
    var subscribeToDeath = function (fn) {
        return onDeath.subscribe(fn);
    };
    var subscribeToHealthChange = function (fn) {
        return onHealthChange.subscribe(fn);
    };
    return {
        takeDamage: takeDamage,
        heal: heal,
        getHP: getHP,
        kill: kill,
        subscribeToDeath: subscribeToDeath,
        subscribeToHealthChange: subscribeToHealthChange,
        setMaxHP: setMaxHP,
        spawnHitSplat: spawnHitSplat,
    };
};
exports.Health = Health;
var HealthBar = function (_a) {
    var maxHP = _a.maxHP, hp = _a.hp, sprite = _a.sprite;
    var UIContainer = app_1.appService.UIContainer, app = app_1.appService.app;
    var width = sprite.width, height = sprite.height, x = sprite.x, y = sprite.y;
    var hpContainer = new pixi_js_1.Container();
    var healthBarHeight = 5;
    var heightOffset = 10;
    var xOffset = -width / 2;
    var yOffset = (-height / 2) - heightOffset;
    // TODO: look into creating a reference object and cloning it with .clone()
    var bg = new pixi_js_1.Graphics();
    bg.beginFill(0xff5555);
    bg.drawRect(xOffset, yOffset, width, healthBarHeight);
    bg.endFill();
    var healthBar = new pixi_js_1.Graphics();
    var updateHealth = function (newHP, maxHP) {
        if (newHP === maxHP) {
            hpContainer.alpha = 0;
        }
        else {
            hpContainer.alpha = 0.8;
        }
        healthBar.clear();
        healthBar.beginFill(0x55ff55);
        healthBar.drawRect(xOffset, yOffset, width * (newHP / maxHP), healthBarHeight);
        healthBar.endFill();
    };
    updateHealth(hp, maxHP);
    hpContainer.addChild(bg);
    hpContainer.addChild(healthBar);
    UIContainer.addChild(hpContainer);
    var followSprite = function () {
        if (hpContainer.alpha === 0)
            return;
        hpContainer.position.set(sprite.x, sprite.y);
    };
    app.ticker.add(followSprite);
    var clearHealthBar = function () {
        app.ticker.remove(followSprite);
        hpContainer.destroy();
    };
    return {
        updateHealth: updateHealth,
        clearHealthBar: clearHealthBar,
    };
};
